import React from 'react'
import Dashboard from '../components/Dashboard/Dashboard'
import ResourceLinkNav from '../components/shared/ResourceLinkNav/ResourceLinkNav'
import AdminView from '../components/shared/AdminView'

function DashboardPage() {
  return (
    <ResourceLinkNav>
      <AdminView />
      <Dashboard />
    </ResourceLinkNav>
  )
}

export default DashboardPage